import { AfterViewInit, Component, effect, model, untracked, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { xDecimalPlacesAsFractionDigits } from '@phoenix/common';
import { DocumentLineItem } from '../../../generated/generated-types';
import { StorageQuantityNumberInputComponent } from '../storage-quantity-number-input/storage-quantity-number-input.component';

@Component({
  selector: 'app-formly-storage-quantity-input',
  templateUrl: './formly-storage-quantity-input.component.html',
  standalone: true,
  imports: [
    StorageQuantityNumberInputComponent,
    ReactiveFormsModule,
    FormlyModule
  ]
})
export class FormlyStorageQuantityInputComponent extends FieldType implements AfterViewInit {

  @ViewChild('input') input: StorageQuantityNumberInputComponent

  documentLineItem = model<DocumentLineItem>();
  minFractionDigits = model<number>();
  maxFractionDigits = model<number>();
  quantityStep = model<number>();
  upDownButtons = model<boolean>();

  constructor() {
    super();
    effect(() => {
      const lineItem = this.documentLineItem();
      untracked(() => {
        if (!lineItem) {
          return;
        }

        const fractionDigits = xDecimalPlacesAsFractionDigits(this.resolveQuantityDecimalPlaces(lineItem));
        this.minFractionDigits.set(fractionDigits);
        this.maxFractionDigits.set(fractionDigits);

        const step = lineItem.unit?.quantityStep;
        if (step) {
          this.quantityStep.set(step);
        }
      });
    });
  }

  private resolveQuantityDecimalPlaces(lineItem: DocumentLineItem): number {
    let decimalPlaces = lineItem.unit?.decimalPlaces ?? lineItem.decimalPlaces;
    if (!decimalPlaces || decimalPlaces === 0) {
      decimalPlaces = 0.01;
    }
    return decimalPlaces;
  }

  ngOnInit(): void {
    if (this.model && !this.documentLineItem()) {
      this.documentLineItem.set(this.model);
    }
  }

  ngAfterViewInit(): void {
    if (this.input)
      this.input.quantityStatus = this.field.props?.quantityStatus

  }

  valueChanged(event: any) {
    if (this.formControl)
      this.formControl.setValue(event);
  }
}
